// Lo que se guarda son provincias: `value` numérico y sin `provId`. El texto
// y el `provId` opcional están para aceptar el item tal como lo entrega la
// lista al seleccionar, que declara `value` como texto.
interface MostUsedProv {
  label: string;
  value: string | number | null;
  provId?: string | null;
  count: number;
}

interface MostUsedLoc {
  label: string;
  value: string;
  provId: string | null;
  count: number;
}

let getLocalStorage = function (): Storage {
  return window && window.localStorage
    ? window.localStorage
    : ({ currentLang: "es" } as unknown as Storage);
};

const localRepository = {
  clear: function () {
    getLocalStorage().clear();
  },

  accessToken: {
    get: function (): string | null {
      return getLocalStorage().accessToken
        ? getLocalStorage().accessToken
        : null;
    },
    set: function (accessToken: string) {
      getLocalStorage().accessToken = accessToken;
    },
  },

  featureFlags: {
    get: function (): Record<string, unknown> {
      return getLocalStorage().featureFlags
        ? JSON.parse(getLocalStorage().featureFlags)
        : {};
    },
    set: function (featureFlags: Record<string, unknown>) {
      getLocalStorage().featureFlags = JSON.stringify(featureFlags);
    },
  },

  mostUsedProv: {
    get: function (): MostUsedProv[] {
      const stored = localStorage.getItem("mostUsedProv");
      return stored ? JSON.parse(stored) : [];
    },
    set: function (state: Omit<MostUsedProv, "count">) {
      const mostUs = this.get();
      const prov = mostUs.filter(
        (prov) => prov.label === state.label && state.provId === prov.provId
      );
      if (prov.length > 0) prov[0].count++;
      else mostUs.push({ ...state, count: 0 });
      localStorage.setItem("mostUsedProv", JSON.stringify(mostUs));
    },
    clear: () => {
      localStorage.removeItem("mostUsedProv");
    },
  },
  mostUsedLoc: {
    get: function (): MostUsedLoc[] {
      const stored = localStorage.getItem("mostUsedLoc");
      return stored ? JSON.parse(stored) : [];
    },
    set: function (state: Omit<MostUsedLoc, "count">) {
      const mostUs = this.get();
      const loc = mostUs.filter((loc) => loc.label === state.label);
      if (loc.length > 0) loc[0].count++;
      else mostUs.push({ ...state, count: 0 });
      localStorage.setItem("mostUsedLoc", JSON.stringify(mostUs));
    },
    clear: () => {
      localStorage.removeItem("mostUsedLoc");
    },
  },
};

export default localRepository;
